import React, { useState } from "react";
import {
  FormControl,
  FormLabel,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Controller } from "react-hook-form";

const FormTextInput = ({
  name,
  type = "text",
  label,
  required,
  placeholder,
  control,
  validationSchema,
  errors,
  onInputChange,
  startAdornment = null,
  endAdornment = null,
  fullWidth = true,
  variant = "outlined",
  disabled = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      {label && (
        <FormLabel
          sx={{
            mb: 1,
            display: "block",
            fontSize: "14px",
            color: "#4B5563",
            fontWeight: 600,
          }}
        >
          {label}{" "}
          {required && (
            <Typography
              component="span"
              color="error"
              sx={{ lineHeight: "normal" }}
            >
              *
            </Typography>
          )}
        </FormLabel>
      )}
      <FormControl error={!!errors} sx={{ width: "100%" }}>
        <Controller
          name={name}
          control={control}
          rules={validationSchema}
          render={({ field: { onChange, value } }) => (
            <TextField
              type={showPassword ? "text" : type}
              placeholder={placeholder}
              variant={variant}
              fullWidth={fullWidth}
              value={value || ""}
              onChange={(e) => {
                onChange(e.target.value);
                if (onInputChange) {
                  onInputChange(e.target.value);
                }
              }}
              InputProps={{
                autoComplete: "new-password",
                startAdornment: startAdornment && (
                  <InputAdornment
                    position="start"
                    sx={{ mt: "0 !important", color: "#000000" }}
                  >
                    {startAdornment}
                  </InputAdornment>
                ),
                endAdornment:
                  (type === "password" || endAdornment) && (
                    <InputAdornment
                      position="end"
                      sx={{
                        mt: "0 !important",
                        color: "#000000",
                        cursor: "pointer",
                      }}
                      onClick={
                        type === "password" ? togglePasswordVisibility : undefined
                      }
                    >
                      {type === "password" ? (
                        !showPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )
                      ) : (
                        endAdornment
                      )}
                    </InputAdornment>
                  ),
              }}
              error={!!errors}
              helperText={errors}
              disabled={disabled}
              sx={{
                "& .MuiFormHelperText-root.Mui-error": {
                  color: "#e23c27 !important",
                  marginLeft: 0
                },
              }}
            />
          )}
        />
      </FormControl>
    </>
  );
};

export default FormTextInput;
